var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((_vm._value),function(org,index){return _c('a-tag',{key:index + '_org',staticClass:"org-item",attrs:{"type":org.type === 'dept'?'':'info',"closable":""},on:{"close":function($event){return _vm.removeOrgItem(index)}}},[_vm._v(" "+_vm._s(org.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }